export const TimeType = {
    BEFORE: "전" as const,
    AFTER: "후" as const,
} as const;
